import * as React from 'react';
type Props = {
  className?: string;
};
export function Calendar({ className }: Props) {
  return (
    <svg
      viewBox="0 0 50 50"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      data-testid="illustrated-Calendar"
      className={className}
    >
      <rect width={50} height={50} rx={25} fill="#EBEEF6" />
      <rect
        x={7.01953}
        y={10.8052}
        width={36.8}
        height={30.9091}
        rx={3.5}
        fill="white"
        stroke="currentColor"
      />
      <rect
        x={12.4199}
        y={7.85986}
        width={3.90909}
        height={6.85455}
        rx={1.95455}
        fill="white"
        stroke="currentColor"
      />
      <rect
        x={34.5107}
        y={7.85986}
        width={3.90909}
        height={6.85455}
        rx={1.95455}
        fill="white"
        stroke="currentColor"
      />
      <line
        x1={6.51953}
        y1={18.6416}
        x2={44.3195}
        y2={18.6416}
        stroke="currentColor"
      />
    </svg>
  );
}
